import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import { queryStringContaining } from '@jane/bloom/utils/queryParams/preservingQueryParams';
import { DRAFT_QUERY_KEY } from '@jane/bloom/utils/queryParams/queryParams';
import { withoutInitialSlashes } from '@jane/bloom/utils/strings/withoutInitialSlashes';

/**
 * Provides a function that builds a url, including the basename and query params that persist across pages.
 */
export const useFullDestination = () => {
  const basename = useBloomBasename();
  const [searchParams] = useSearchParams();

  return useCallback(
    (to: string) => {
      const queryParams = queryStringContaining({
        paramKeys: [DRAFT_QUERY_KEY],
        prefix: to.includes('?') ? '&' : '?',
        searchParams,
      });

      return `${basename}${withoutInitialSlashes(to)}${queryParams}`;
    },
    [basename, searchParams]
  );
};
